export function proxyTip(item: any) {
  return [
    `名称：${item.name}`,
    `用户名：${item.username}`,
    `地址：${item.typeText}://${item.host}:${item.port}`,
    `出口IP：${item.outIp}`,
    `归属地：${item.area}`,
    proxyStatusTip(item),
  ].join('\n');
}

export function proxyStatusTip(item: any) {
  if (item.status === 'normal') {
    return '状态：正常';
  } else if (item.status === 'error') {
    return '状态：异常';
  } else {
    return '状态：未检测';
  }
}
